const $ = jQuery.noConflict();

class DonorBlockSlider {
    constructor() {
        this.sliders = $('.top-donors__cards');
        this.breakpoint = 768;
    }

    init() {
        this.initSlider();
    }

    initSlider() {
        this.sliders.slick({
            arrows: true,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            responsive: [
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: this.breakpoint,
                    settings: "unslick"
                }
            ]
        });
    }

    resized() {
        if (window.matchMedia(`(max-width: ${this.breakpoint}px)`).matches && !this.sliders.hasClass('slick-initialized')) {
            this.initSlider();
        }
    }
}

export default new DonorBlockSlider;
